import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AUTH_GUARD } from './core/guards/auth.guard';
import { NotFound404Component } from './features/auth/not-found/pages/not-found-404/not-found-404.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { WebLayoutComponent } from './layouts/web-layout/web-layout.component';

const routes: Routes = [
    { path: '', redirectTo: 'landing', pathMatch: 'full' },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./layouts/auth-layout/auth-layout-module').then((m) => m.AuthLayoutModule),
            },
        ],
    },
    {
        path: '',
        component: WebLayoutComponent,
        canActivate: [AUTH_GUARD],
        children: [
            {
                path: '',
                loadChildren: () => import('./layouts/web-layout/web-layout-module').then((m) => m.WebLayoutModule),
            },
        ],
    },
    { path: '**', component: NotFound404Component },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled', // Scrolls to top on navigation
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
